import { FC } from "react";

import { SVG_MUI } from "@ryde/assets";
import { CHECKBOX_DEFAULT_SIZE } from "@ryde/shared";

import { CheckboxUserContainerStyled } from "./checkboxes.styled";

interface ICheckboxUserProps {
  checked: boolean;
  catchARide?: boolean;
  width?: number;
  height?: number;
  color?: string;
  setChecked: (checked: boolean) => void;
}

export const CheckboxUser: FC<ICheckboxUserProps> = ({
  checked,
  setChecked,
  catchARide = false,
  width = CHECKBOX_DEFAULT_SIZE,
  height = CHECKBOX_DEFAULT_SIZE,
  color,
}) => {
  const UncheckedIcon = catchARide ? SVG_MUI.CatchRide2SVG : SVG_MUI.User2SVG;
  const CheckedIcon = catchARide
    ? SVG_MUI.CatchRideFilled2SVG
    : SVG_MUI.UserFilled2SVG;

  return (
    <CheckboxUserContainerStyled
      data-e2e-value={checked ? "checked" : "unchecked"}
      $color={color}
    >
      {!checked && (
        <UncheckedIcon
          onClick={() => setChecked(true)}
          width={width}
          height={height}
        />
      )}
      {checked && (
        <CheckedIcon
          onClick={() => setChecked(false)}
          width={width}
          height={height}
        />
      )}
    </CheckboxUserContainerStyled>
  );
};
